import { EuiCopy, EuiButtonEmpty } from "@elastic/eui";

export const formatError = ({ errorId, text }) => {
  if (!errorId) return text;

  return (
    <>
      <p>{text}</p>
      <EuiCopy textToCopy={errorId}>
        {(copy) => (
          <EuiButtonEmpty iconType="copy" iconSide="right" onClick={copy} color="danger">
            {`# ${errorId}`}
          </EuiButtonEmpty>
        )}
      </EuiCopy>
    </>
  );
};
